import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Input from 'components/Input/Input';
import Typography from 'components/Typography/Typography';

export const HeaderStyled = styled.header`
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.variant1};
  white-space: nowrap;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 1.625rem 1.875rem;
    }
  `}
`;

export const FlexContainerStyled = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  align-items: start;
  flex-wrap: wrap;
  ${({ theme }) => `
    ${theme.devices.tabletLandscape} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
    }
  `}
`;

export const MobileContainerStyled = styled(FlexContainer)`
  width: 100%;
  ${({ theme }) => `
    ${theme.devices.tablet} {
     width: auto;
    }
  `}
`;

export const BtnFlexContainerStyled = styled(FlexContainer)`
  gap: 8px;
  flex-wrap: wrap;
  justify-content: start;
  align-self: end;
  ${({ theme }) => `
    ${theme.devices.tabletLandscape} {
      justify-content: space-between;
      flex-wrap: nowrap;
      align-self: center;
      }`}
`;

export const TypographyStyled = styled(Typography)`
  margin-right: 1rem;
`;

export const InputStyled = styled(Input)`
  max-width: 100%;
  min-width: 200px;
  padding-left: 2rem;
  padding-right: 1.75rem;
  margin: 1rem 0;

  ${({ theme }) => `
    ${theme.devices.desktop} {
      margin: 0;
    }
  `}
`;

export const ButtonStyled = styled(Button)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      justify-self: flex-end;
    }
  `}
`;

export const ClearBtnIconStyled = styled(ButtonIcon)`
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.colors.transparent};

      svg path {
        fill: ${({ theme }) => theme.colors.primary.variant1};
      }
    }
  }
`;

export const ClearBtnWrapStyled = styled(FlexContainer)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
`;
